import { ReactComponent as Apple_Safari_Brand } from './brand_logos/Brand=Apple Safari, Style=Brand.svg';
import { ReactComponent as Apple_Black } from './brand_logos/Brand=Apple, Style=Black.svg';
import { ReactComponent as Apple_Brand } from './brand_logos/Brand=Apple, Style=Brand.svg';
import { ReactComponent as Apple_White } from './brand_logos/Brand=Apple, Style=White.svg';
import { ReactComponent as Arc_Black } from './brand_logos/Brand=Arc, Style=Black.svg';
import { ReactComponent as Arc_Brand } from './brand_logos/Brand=Arc, Style=Brand.svg';
import { ReactComponent as Arc_White } from './brand_logos/Brand=Arc, Style=White.svg';
import { ReactComponent as Atlassian_Bitbucket_Black } from './brand_logos/Brand=Atlassian Bitbucket, Style=Black.svg';
import { ReactComponent as Atlassian_Bitbucket_Brand } from './brand_logos/Brand=Atlassian Bitbucket, Style=Brand.svg';
import { ReactComponent as Atlassian_Bitbucket_White } from './brand_logos/Brand=Atlassian Bitbucket, Style=White.svg';
import { ReactComponent as Atlassian_Black } from './brand_logos/Brand=Atlassian, Style=Black.svg';
import { ReactComponent as Atlassian_Brand } from './brand_logos/Brand=Atlassian, Style=Brand.svg';
import { ReactComponent as Atlassian_White } from './brand_logos/Brand=Atlassian, Style=White.svg';
import { ReactComponent as Auth0_Black } from './brand_logos/Brand=Auth0, Style=Black.svg';
import { ReactComponent as Auth0_Brand } from './brand_logos/Brand=Auth0, Style=Brand.svg';
import { ReactComponent as Auth0_White } from './brand_logos/Brand=Auth0, Style=White.svg';
import { ReactComponent as Authy_Black } from './brand_logos/Brand=Authy, Style=Black.svg';
import { ReactComponent as Authy_Brand } from './brand_logos/Brand=Authy, Style=Brand.svg';
import { ReactComponent as Authy_White } from './brand_logos/Brand=Authy, Style=White.svg';
import { ReactComponent as Azure_Black } from './brand_logos/Brand=Azure, Style=Black.svg';
import { ReactComponent as Azure_Brand } from './brand_logos/Brand=Azure, Style=Brand.svg';
import { ReactComponent as Azure_White } from './brand_logos/Brand=Azure, Style=White.svg';
import { ReactComponent as Bluesky_Black } from './brand_logos/Brand=Bluesky, Style=Black.svg';
import { ReactComponent as Bluesky_Brand } from './brand_logos/Brand=Bluesky, Style=Brand.svg';
import { ReactComponent as Bluesky_White } from './brand_logos/Brand=Bluesky, Style=White.svg';
import { ReactComponent as Brave_Black } from './brand_logos/Brand=Brave, Style=Black.svg';
import { ReactComponent as Brave_Brand } from './brand_logos/Brand=Brave, Style=Brand.svg';
import { ReactComponent as Brave_White } from './brand_logos/Brand=Brave, Style=White.svg';
import { ReactComponent as Builder_Black } from './brand_logos/Brand=Builder, Style=Black.svg';
import { ReactComponent as Builder_Brand } from './brand_logos/Brand=Builder, Style=Brand.svg';
import { ReactComponent as Builder_White } from './brand_logos/Brand=Builder, Style=White.svg';
import { ReactComponent as Chromium_Brand } from './brand_logos/Brand=Chromium, Style=Brand.svg';
import { ReactComponent as Contentful_Black } from './brand_logos/Brand=Contentful, Style=Black.svg';
import { ReactComponent as Contentful_Brand } from './brand_logos/Brand=Contentful, Style=Brand.svg';
import { ReactComponent as Contentful_White } from './brand_logos/Brand=Contentful, Style=White.svg';
import { ReactComponent as Cube_Black } from './brand_logos/Brand=Cube, Style=Black.svg';
import { ReactComponent as Cube_White } from './brand_logos/Brand=Cube, Style=White.svg';
import { ReactComponent as Digital_Ocean_Black } from './brand_logos/Brand=Digital Ocean, Style=Black.svg';
import { ReactComponent as Digital_Ocean_Brand } from './brand_logos/Brand=Digital Ocean, Style=Brand.svg';
import { ReactComponent as Digital_Ocean_White } from './brand_logos/Brand=Digital Ocean, Style=White.svg';
import { ReactComponent as Figma_Black } from './brand_logos/Brand=Figma, Style=Black.svg';
import { ReactComponent as Figma_Brand } from './brand_logos/Brand=Figma, Style=Brand.svg';
import { ReactComponent as Figma_White } from './brand_logos/Brand=Figma, Style=White.svg';
import { ReactComponent as GitHub_Black } from './brand_logos/Brand=GitHub, Style=Black.svg';
import { ReactComponent as GitHub_Brand } from './brand_logos/Brand=GitHub, Style=Brand.svg';
import { ReactComponent as GitHub_White } from './brand_logos/Brand=GitHub, Style=White.svg';
import { ReactComponent as GitLab_Black } from './brand_logos/Brand=GitLab, Style=Black.svg';
import { ReactComponent as GitLab_Brand } from './brand_logos/Brand=GitLab, Style=Brand.svg';
import { ReactComponent as GitLab_White } from './brand_logos/Brand=GitLab, Style=White.svg';
import { ReactComponent as Google_Ads_Black } from './brand_logos/Brand=Google Ads, Style=Black.svg';
import { ReactComponent as Google_Ads_Brand } from './brand_logos/Brand=Google Ads, Style=Brand.svg';
import { ReactComponent as Google_Ads_White } from './brand_logos/Brand=Google Ads, Style=White.svg';
import { ReactComponent as Google_CM360_Black } from './brand_logos/Brand=Google CM360, Style=Black.svg';
import { ReactComponent as Google_CM360_Brand } from './brand_logos/Brand=Google CM360, Style=Brand.svg';
import { ReactComponent as Google_CM360_White } from './brand_logos/Brand=Google CM360, Style=White.svg';
import { ReactComponent as Google_Chrome_Brand } from './brand_logos/Brand=Google Chrome, Style=Brand.svg';
import { ReactComponent as Google_YouTube_Black } from './brand_logos/Brand=Google YouTube, Style=Black.svg';
import { ReactComponent as Google_YouTube_Brand } from './brand_logos/Brand=Google YouTube, Style=Brand.svg';
import { ReactComponent as Google_YouTube_White } from './brand_logos/Brand=Google YouTube, Style=White.svg';
import { ReactComponent as Google_Black } from './brand_logos/Brand=Google, Style=Black.svg';
import { ReactComponent as Google_Brand } from './brand_logos/Brand=Google, Style=Brand.svg';
import { ReactComponent as Google_White } from './brand_logos/Brand=Google, Style=White.svg';
import { ReactComponent as LinkedIn_Black } from './brand_logos/Brand=LinkedIn, Style=Black.svg';
import { ReactComponent as LinkedIn_Brand } from './brand_logos/Brand=LinkedIn, Style=Brand.svg';
import { ReactComponent as LinkedIn_White } from './brand_logos/Brand=LinkedIn, Style=White.svg';
import { ReactComponent as Meta_Facebook_Black } from './brand_logos/Brand=Meta Facebook, Style=Black.svg';
import { ReactComponent as Meta_Facebook_Brand } from './brand_logos/Brand=Meta Facebook, Style=Brand.svg';
import { ReactComponent as Meta_Facebook_White } from './brand_logos/Brand=Meta Facebook, Style=White.svg';
import { ReactComponent as Meta_Black } from './brand_logos/Brand=Meta, Style=Black.svg';
import { ReactComponent as Meta_Brand } from './brand_logos/Brand=Meta, Style=Brand.svg';
import { ReactComponent as Meta_White } from './brand_logos/Brand=Meta, Style=White.svg';
import { ReactComponent as Microsoft_Edge_Black } from './brand_logos/Brand=Microsoft Edge, Style=Black.svg';
import { ReactComponent as Microsoft_Edge_Brand } from './brand_logos/Brand=Microsoft Edge, Style=Brand.svg';
import { ReactComponent as Microsoft_Edge_White } from './brand_logos/Brand=Microsoft Edge, Style=White.svg';
import { ReactComponent as Microsoft_Black } from './brand_logos/Brand=Microsoft, Style=Black.svg';
import { ReactComponent as Microsoft_Brand } from './brand_logos/Brand=Microsoft, Style=Brand.svg';
import { ReactComponent as Microsoft_White } from './brand_logos/Brand=Microsoft, Style=White.svg';
import { ReactComponent as Mozilla_Firefox_Brand } from './brand_logos/Brand=Mozilla Firefox, Style=Brand.svg';
import { ReactComponent as Okta_Black } from './brand_logos/Brand=Okta, Style=Black.svg';
import { ReactComponent as Okta_Brand } from './brand_logos/Brand=Okta, Style=Brand.svg';
import { ReactComponent as Okta_White } from './brand_logos/Brand=Okta, Style=White.svg';
import { ReactComponent as OpenAI_Black } from './brand_logos/Brand=OpenAI, Style=Black.svg';
import { ReactComponent as OpenAI_Brand } from './brand_logos/Brand=OpenAI, Style=Brand.svg';
import { ReactComponent as OpenAI_White } from './brand_logos/Brand=OpenAI, Style=White.svg';
import { ReactComponent as Opera_Black } from './brand_logos/Brand=Opera, Style=Black.svg';
import { ReactComponent as Opera_Brand } from './brand_logos/Brand=Opera, Style=Brand.svg';
import { ReactComponent as Opera_White } from './brand_logos/Brand=Opera, Style=White.svg';
import { ReactComponent as Payload_Black } from './brand_logos/Brand=Payload, Style=Black.svg';
import { ReactComponent as Payload_Brand } from './brand_logos/Brand=Payload, Style=Brand.svg';
import { ReactComponent as Payload_White } from './brand_logos/Brand=Payload, Style=White.svg';
import { ReactComponent as Shopify_Black } from './brand_logos/Brand=Shopify, Style=Black.svg';
import { ReactComponent as Shopify_Brand } from './brand_logos/Brand=Shopify, Style=Brand.svg';
import { ReactComponent as Shopify_White } from './brand_logos/Brand=Shopify, Style=White.svg';
import { ReactComponent as Storyblok_Black } from './brand_logos/Brand=Storyblok, Style=Black.svg';
import { ReactComponent as Storyblok_Brand } from './brand_logos/Brand=Storyblok, Style=Brand.svg';
import { ReactComponent as Storyblok_White } from './brand_logos/Brand=Storyblok, Style=White.svg';
import { ReactComponent as Strapi_Black } from './brand_logos/Brand=Strapi, Style=Black.svg';
import { ReactComponent as Strapi_Brand } from './brand_logos/Brand=Strapi, Style=Brand.svg';
import { ReactComponent as Strapi_White } from './brand_logos/Brand=Strapi, Style=White.svg';
import { ReactComponent as Tor_Black } from './brand_logos/Brand=Tor, Style=Black.svg';
import { ReactComponent as Tor_Brand } from './brand_logos/Brand=Tor, Style=Brand.svg';
import { ReactComponent as Tor_White } from './brand_logos/Brand=Tor, Style=White.svg';
import { ReactComponent as Vivaldi_Black } from './brand_logos/Brand=Vivaldi, Style=Black.svg';
import { ReactComponent as Vivaldi_Brand } from './brand_logos/Brand=Vivaldi, Style=Brand.svg';
import { ReactComponent as Vivaldi_White } from './brand_logos/Brand=Vivaldi, Style=White.svg';
import { ReactComponent as Wordpress_Black } from './brand_logos/Brand=Wordpress, Style=Black.svg';
import { ReactComponent as Wordpress_Brand } from './brand_logos/Brand=Wordpress, Style=Brand.svg';
import { ReactComponent as Wordpress_White } from './brand_logos/Brand=Wordpress, Style=White.svg';
import { ReactComponent as X_Black } from './brand_logos/Brand=X, Style=Black.svg';
import { ReactComponent as X_Brand } from './brand_logos/Brand=X, Style=Brand.svg';
import { ReactComponent as X_White } from './brand_logos/Brand=X, Style=White.svg';
import { ReactComponent as Folder_Yellow } from './brand_logos/folder_yellow.svg';
import { ReactComponent as File } from './brand_logos/file.svg';
import { ReactComponent as Tiktok_Brand } from './brand_logos/Brand=Tiktok, Style=Brand.svg';

export const logoFiles = {
  apple_Safari_Brand: Apple_Safari_Brand,
  apple_Black: Apple_Black,
  apple_Brand: Apple_Brand,
  apple_White: Apple_White,
  arc_Black: Arc_Black,
  arc_Brand: Arc_Brand,
  arc_White: Arc_White,
  atlassian_Bitbucket_Black: Atlassian_Bitbucket_Black,
  atlassian_Bitbucket_Brand: Atlassian_Bitbucket_Brand,
  atlassian_Bitbucket_White: Atlassian_Bitbucket_White,
  atlassian_Black: Atlassian_Black,
  atlassian_Brand: Atlassian_Brand,
  atlassian_White: Atlassian_White,
  auth0_Black: Auth0_Black,
  auth0_Brand: Auth0_Brand,
  auth0_White: Auth0_White,
  authy_Black: Authy_Black,
  authy_Brand: Authy_Brand,
  authy_White: Authy_White,
  azure_Black: Azure_Black,
  azure_Brand: Azure_Brand,
  azure_White: Azure_White,
  bluesky_Black: Bluesky_Black,
  bluesky_Brand: Bluesky_Brand,
  bluesky_White: Bluesky_White,
  brave_Black: Brave_Black,
  brave_Brand: Brave_Brand,
  brave_White: Brave_White,
  builder_Black: Builder_Black,
  builder_Brand: Builder_Brand,
  builder_White: Builder_White,
  chromium_Brand: Chromium_Brand,
  contentful_Black: Contentful_Black,
  contentful_Brand: Contentful_Brand,
  contentful_White: Contentful_White,
  cube_Black: Cube_Black,
  cube_White: Cube_White,
  digital_Ocean_Black: Digital_Ocean_Black,
  digital_Ocean_Brand: Digital_Ocean_Brand,
  digital_Ocean_White: Digital_Ocean_White,
  figma_Black: Figma_Black,
  figma_Brand: Figma_Brand,
  figma_White: Figma_White,
  gitHub_Black: GitHub_Black,
  gitHub_Brand: GitHub_Brand,
  gitHub_White: GitHub_White,
  gitLab_Black: GitLab_Black,
  gitLab_Brand: GitLab_Brand,
  gitLab_White: GitLab_White,
  google_Ads_Black: Google_Ads_Black,
  google_Ads_Brand: Google_Ads_Brand,
  google_Ads_White: Google_Ads_White,
  google_CM360_Black: Google_CM360_Black,
  google_CM360_Brand: Google_CM360_Brand,
  google_CM360_White: Google_CM360_White,
  google_Chrome_Brand: Google_Chrome_Brand,
  google_YouTube_Black: Google_YouTube_Black,
  google_YouTube_Brand: Google_YouTube_Brand,
  google_YouTube_White: Google_YouTube_White,
  google_Black: Google_Black,
  google_Brand: Google_Brand,
  google_White: Google_White,
  linkedIn_Black: LinkedIn_Black,
  linkedIn_Brand: LinkedIn_Brand,
  linkedIn_White: LinkedIn_White,
  meta_Facebook_Black: Meta_Facebook_Black,
  meta_Facebook_Brand: Meta_Facebook_Brand,
  meta_Facebook_White: Meta_Facebook_White,
  meta_Black: Meta_Black,
  meta_Brand: Meta_Brand,
  meta_White: Meta_White,
  microsoft_Edge_Black: Microsoft_Edge_Black,
  microsoft_Edge_Brand: Microsoft_Edge_Brand,
  microsoft_Edge_White: Microsoft_Edge_White,
  microsoft_Black: Microsoft_Black,
  microsoft_Brand: Microsoft_Brand,
  microsoft_White: Microsoft_White,
  mozilla_Firefox_Brand: Mozilla_Firefox_Brand,
  okta_Black: Okta_Black,
  okta_Brand: Okta_Brand,
  okta_White: Okta_White,
  openAI_Black: OpenAI_Black,
  openAI_Brand: OpenAI_Brand,
  openAI_White: OpenAI_White,
  opera_Black: Opera_Black,
  opera_Brand: Opera_Brand,
  opera_White: Opera_White,
  payload_Black: Payload_Black,
  payload_Brand: Payload_Brand,
  payload_White: Payload_White,
  shopify_Black: Shopify_Black,
  shopify_Brand: Shopify_Brand,
  shopify_White: Shopify_White,
  storyblok_Black: Storyblok_Black,
  storyblok_Brand: Storyblok_Brand,
  storyblok_White: Storyblok_White,
  strapi_Black: Strapi_Black,
  strapi_Brand: Strapi_Brand,
  strapi_White: Strapi_White,
  tor_Black: Tor_Black,
  tor_Brand: Tor_Brand,
  tor_White: Tor_White,
  tiktok_Brand: Tiktok_Brand,
  vivaldi_Black: Vivaldi_Black,
  vivaldi_Brand: Vivaldi_Brand,
  vivaldi_White: Vivaldi_White,
  wordpress_Black: Wordpress_Black,
  wordpress_Brand: Wordpress_Brand,
  wordpress_White: Wordpress_White,
  x_Black: X_Black,
  x_Brand: X_Brand,
  x_White: X_White,
  file: File,
  folder_Yellow: Folder_Yellow
} as const;
